class SquarePaymentFailure extends Error {
  constructor(message, { code, category, reason, response, noStack = true }) {
    super(message)
    this.name = this.constructor.name
    this.message = (message !== undefined) ? `Square Payment Failed - ${message}` : 'Square Payment Fasiled'
    this.code = code
    this.reason = reason
    this.category = category || 'UNKNOWN'
    this.response = response || null

    if (!noStack) {
      // Use V8's native method if available, otherwise fallback
      if ('captureStackTrace' in Error) {
        Error.captureStackTrace(this, this.constructor)
      }
      else {
        this.stack = (new Error()).stack
      }
    }
  }
}

class SquarePaymentError extends Error {
  constructor(message, { code, category, reason, detail, noStack = true }) {
    super(message)
    this.name = this.constructor.name
    this.message = (message !== undefined) ? `Square Payment Error - ${message}` : 'Square Payment Error'
    this.code = code
    this.reason = reason
    this.category = category || 'UNKNOWN'

    if (!noStack) {
      // Use V8's native method if available, otherwise fallback
      if ('captureStackTrace' in Error) {
        Error.captureStackTrace(this, this.constructor)
      }
      else {
        this.stack = (new Error()).stack
      }
    }
  }
}

class SquareServiceError extends Error {
  constructor(message, { code, category, reason, noStack = true }) {
    super(message)
    this.name = this.constructor.name
    this.message = (message !== undefined) ? `Square Service Error - ${message}` : 'Square Service Error'
    this.code = code
    this.reason = reason
    this.category = category || 'UNKNOWN'

    if (!noStack) {
      // Use V8's native method if available, otherwise fallback
      if ('captureStackTrace' in Error) {
        Error.captureStackTrace(this, this.constructor)
      }
      else {
        this.stack = (new Error()).stack
      }
    }
  }
}
class SquareErrorList extends Error {
  constructor(errorList, { noStack = true }) {
    super('Multiple Square Payment errors')
    this.name = this.constructor.name
    this.errorList = errorList

    if (!noStack) {
    // Use V8's native method if available, otherwise fallback
      if ('captureStackTrace' in Error) {
        Error.captureStackTrace(this, this.constructor)
      }
      else {
        this.stack = (new Error()).stack
      }
    }
  }
}

class SquareCardTokenizationError extends Error {
  constructor(message, { tokenizeResult, category, reason, details, retryable, noStack = true }) {
    super(message)
    this.tokenizeResult = tokenizeResult || null
    this.name = this.constructor.name
    this.message = (message !== undefined) ? `Square Card Tokenization Error - ${message}` : 'Square Card Tokenization Error'
    this.reason = reason || 'An unknown error occurred during card tokenization'
    this.category = category || 'CARD-TOKENIZATION'
    this.details = details || null

    this.retryable = retryable || false

    if (!noStack) {
      // Use V8's native method if available, otherwise fallback
      if ('captureStackTrace' in Error) {
        Error.captureStackTrace(this, this.constructor)
      }
      else {
        this.stack = (new Error()).stack
      }
    }
  }
}

export {
  SquarePaymentError,
  SquareServiceError,
  SquareErrorList,
  SquarePaymentFailure,
  SquareCardTokenizationError
}
